// Browser metadata is for display only; the server validates the HttpOnly cookie.
let expiryTimer;
let expiryNotified = false;

export function clearUserSession() {
  clearTimeout(expiryTimer);
  localStorage.removeItem('rassplSessionId');
  localStorage.removeItem('rassplUser');
}

export function currentUser() {
  try {
    return JSON.parse(localStorage.getItem('rassplUser') || 'null');
  } catch {
    clearUserSession();
    return null;
  }
}

export function hasValidSession() {
  const user = currentUser();
  return !!user && Date.parse(user.expiresAt) > Date.now();
}

export function expireSession() {
  clearUserSession();
  // A rejected cookie still needs a redirect when browser metadata is absent.
  if (!expiryNotified) {
    expiryNotified = true;
    window.dispatchEvent(new Event('rasspl-session-expired'));
  }
}

export function scheduleSessionExpiry() {
  clearTimeout(expiryTimer);
  const user = currentUser();
  if (!user) return;
  const remaining = Date.parse(user.expiresAt) - Date.now();
  if (!Number.isFinite(remaining) || remaining <= 0) {
    expireSession();
    return;
  }
  expiryNotified = false;
  // Recheck long lifetimes without overflowing the browser's timer limit.
  expiryTimer = setTimeout(scheduleSessionExpiry, Math.min(remaining, 2147483647));
}

export function initializeSessionHandling(router) {
  expiryNotified = false;
  window.addEventListener('rasspl-session-expired', () => {
    router.replace({ name: 'login', query: { reason: 'expired' } });
  });
  window.addEventListener('focus', scheduleSessionExpiry);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) scheduleSessionExpiry();
  });
  window.addEventListener('storage', (event) => {
    if (event.key !== 'rassplUser' && event.key !== null) return;
    scheduleSessionExpiry();
    if (!currentUser() && router.currentRoute.value.meta.requiresAuth) {
      router.replace({ name: 'login' });
    }
  });
  scheduleSessionExpiry();
}
